"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const Picasso_1 = require("../Picasso");
Picasso_1.PicassoProvider.override(() => ({
    MuiLink: {
        root: {
            cursor: 'pointer'
        }
    }
}));
exports.default = () => styles_1.createStyles({
    action: {
        fontWeight: 600
    }
});
//# sourceMappingURL=styles.js.map